import BgGlassmorphism from "components/BgGlassmorphism/BgGlassmorphism";
import { Helmet } from "react-helmet-async";
import SectionHeroArchivePage from "components/SectionHeroArchivePage/SectionHeroArchivePage";
import { FC, useContext, useEffect, useState } from "react";
import heroRightImage from "images/hero-right-car.png";
import SectionGridFilterCard from "containers/ListingCarPage/SectionGridFilterCard";
import useFetch from "hooks/useFetch";
import SectionVideos from "containers/PageHome/SectionVideos";
import Step from "components/StepSection/StepSection";
import { AuthContext } from "context/authContext";
import axiosInstance from "../utils/axiosInstance";
import { motion } from "framer-motion";
import { ContactForm } from "./contact";
import homeCover from "../images/goodwaycar-hkrent.jpeg";

export interface ListingCarPageProps {
  className?: string;
}

const HomePage: FC<ListingCarPageProps> = ({ className = "" }) => {
  const { user } = useContext(AuthContext);
  const { data, loading } = useFetch("/api/v1/cars");
  const [wishlists, setWishList] = useState([]);

  useEffect(() => {
    const fetchWishList = async () => {
      try {
        const res = await axiosInstance.get(
          `/api/v1/users/getcarid/${user._id}`
        );
        setWishList(res.data.carList);
      } catch (error) {
        console.log(error);
      }
    };
    if (user) {
      fetchWishList();
    }
  }, [user]);

  const sectionVariants = {
    hidden: { opacity: 0, y: 0 },
    visible: { opacity: 1, y: 0 },
  };

  return (
    <motion.div
      className={`nc-ListingCarPage ${className} relative lg:static `}
      data-nc-id="ListingCarPage"
      variants={sectionVariants}
      initial="hidden"
      animate="visible"
    >
        <Helmet>
        <title>長勝租車 GoodwayPass Car Rental - 香港合法汽車租賃公司</title>
        <meta 
          name="description" 
          content="長勝租車 | 香港合法汽車租賃公司, 擁有超過200部名貴車款可供選擇, 九龍城廣場九龍中店舖, 一站式本地租車平台, 實時查看車輛租用情況, 每部租車車輛均含有合法「汽車租賃」租車保險, 只需網上預約時間提供簡單文件即可簽約取車!" 
        />
          <meta name="description" content="長勝租車 | 香港合法汽車租賃公司, 擁有超過200部名貴車款可供選擇..." />
          <meta name="keywords" content="租車,香港租車,汽車租賃,長勝租車" />
          <meta property="og:title" content="長勝租車 GoodwayPass Car Rental" />
          <meta property="og:description" content="香港合法汽車租賃公司" />
          <meta property="og:type" content="website" />
          <link rel="canonical" href="https://goodwaypass.com.hk/" />
      </Helmet>
      <BgGlassmorphism images={homeCover} />
    
      <div className="container relative">
        {/* SECTION 1 */}

        <div className="container relative">
          <SectionHeroArchivePage
            rightImage={heroRightImage}
            currentPage="Cars"
            currentTab="Cars"
            className="  pt-10 pb-24 lg:pb-28 lg:pt-16 a "
          />
        </div>

        {/* SECTION 2 */}

        <SectionGridFilterCard
          data={data}
          className="pb-24 pt-10 lg:pt-0 lg:pb-28"
          loading={loading}
          wishList={wishlists}
          itemsPerPage={20}
        />
      </div>
      {/* SECTION 3 */}
      <Step />
      <div className="container relative">
        {/* SECTION 4 */}
        <SectionVideos />

        {/* SECTION 5 */}

        <ContactForm />
      </div>
    </motion.div>
  );
};

export default HomePage;
